import React from 'react';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import { DIALOG_TYPE } from '../../../../constants/DialogTypes';
import { Button } from '../Buttons';

interface IDialogActionButtons {
  onClose: () => void;
  handleApply: () => void;
  dialogType?: DIALOG_TYPE;
  justify?: 'start' | 'center' | 'end';
  actionButton: string;
  cancelButton?: string;
  disabled?: boolean;
}

export const DialogActionButtons = ({
  onClose,
  handleApply,
  dialogType,
  justify = 'end',
  actionButton,
  cancelButton,
  disabled,
}: IDialogActionButtons) => {
  const justification =
    justify === 'start'
      ? 'flex-start'
      : justify === 'center'
        ? 'center'
        : 'flex-end';

  return (
    <DialogActions
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: justification,
        gap: 1.5,
        borderTop: '1px solid',
        borderColor: 'divider',
        pt: 2.5,
        px: 0,
        pb: 0,
      }}
    >
      {cancelButton && (
        <Button label={cancelButton} onClick={onClose} variant="secondary" />
      )}
      {actionButton ? (
        <Button
          label={actionButton}
          onClick={handleApply}
          dialogType={dialogType}
          variant="primary"
          disabled={disabled}
          type="submit"
        />
      ) : null}
    </DialogActions>
  );
};

